import { render, staticRenderFns } from "./JdiContent.vue?vue&type=template&id=7fca9d19&scoped=true&"
import script from "./JdiContent.vue?vue&type=script&lang=ts&"
export * from "./JdiContent.vue?vue&type=script&lang=ts&"
import style0 from "./JdiContent.vue?vue&type=style&index=0&id=7fca9d19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca9d19",
  null
  
)

export default component.exports